import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";

// Importa suas "páginas"
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import CategoryManager from "./components/CategoryManager";
import WhatsAppManager from "./components/WhatsAppManager";
import AffiliateSettings from "./components/AffiliateSettings";
import Users from "./pages/Users";
import BannerManagement from "./pages/BannerManagement";
import StoreManagement from "./pages/StoreManagement";
import CommentsManager from "./components/CommentsManager";
import BlogManager from "./components/BlogManager";
import ProductManager from "./components/ProductManager";
import PrivateRoute from "./components/PrivateRoute";

import QueueStatus from "./components/QueueStatus";
import ReceiptValidation from "./pages/ReceiptValidation";
import RedemptionRequests from "./pages/RedemptionRequests";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="app-container">
          <Routes>
            {/* ROTA PÚBLICA */}
            <Route path="/login" element={<Login />} />

            {/* ROTAS PROTEGIDAS */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            <Route
              path="/categorias"
              element={
                <PrivateRoute>
                  <CategoryManager />
                </PrivateRoute>
              }
            />

            <Route
              path="/produtos"
              element={
                <PrivateRoute>
                  <ProductManager />
                </PrivateRoute>
              }
            />

            <Route
              path="/whatsapp"
              element={
                <PrivateRoute>
                  <WhatsAppManager />
                </PrivateRoute>
              }
            />

            <Route
              path="/affiliates"
              element={
                <PrivateRoute>
                  <AffiliateSettings />
                </PrivateRoute>
              }
            />

            <Route
              path="/usuarios"
              element={
                <PrivateRoute requiredRole="admin">
                  <Users />
                </PrivateRoute>
              }
            />

            <Route
              path="/banners"
              element={
                <PrivateRoute>
                  <BannerManagement />
                </PrivateRoute>
              }
            />

            <Route
              path="/lojas"
              element={
                <PrivateRoute>
                  <StoreManagement />
                </PrivateRoute>
              }
            />

            <Route
              path="/blog"
              element={
                <PrivateRoute>
                  <BlogManager />
                </PrivateRoute>
              }
            />

            <Route
              path="/comentarios"
              element={
                <PrivateRoute>
                  <CommentsManager />
                </PrivateRoute>
              }
            />

            <Route
              path="/validacao-notas"
              element={
                <PrivateRoute>
                  <ReceiptValidation />
                </PrivateRoute>
              }
            />

            <Route
              path="/resgates"
              element={
                <PrivateRoute>
                  <RedemptionRequests />
                </PrivateRoute>
              }
            />
          </Routes>

          {/* Status da Fila (Global) */}
          <QueueStatus />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
